import React from "react";
import { CheckCircle2, XCircle, AlertTriangle, Info } from "lucide-react";

/* =======================
   Styles
======================= */
import styles from "./Notification.module.scss";

const Notification = ({ message, type = "success" }) => {
  // Define icon and specific modifier class based on the 'type' prop
  const getNotificationConfig = () => {
    switch (type) {
      case "success":
        return {
          icon: <CheckCircle2 size={20} strokeWidth={2.5} />,
          modifierClass: styles["admin-notification__icon-wrapper--success"],
        };
      case "error":
        return {
          icon: <XCircle size={20} strokeWidth={2.5} />,
          modifierClass: styles["admin-notification__icon-wrapper--error"],
        };
      case "warning":
        return {
          icon: <AlertTriangle size={20} strokeWidth={2.5} />,
          modifierClass: styles["admin-notification__icon-wrapper--warning"],
        };
      case "info":
      default:
        return {
          icon: <Info size={20} strokeWidth={2.5} />,
          modifierClass: styles["admin-notification__icon-wrapper--info"],
        };
    }
  };

  const config = getNotificationConfig();

  return (
    <div className={styles["admin-notification"]} role="alert">
      <span
        className={`${styles["admin-notification__icon-wrapper"]} ${config.modifierClass}`}
      >
        {config.icon}
      </span>
      <span className={styles["admin-notification__msg"]}>{message}</span>
    </div>
  );
};

export default Notification;
